import { EppoContext } from './EppoContext';
import { useInitializeEppo } from './hooks/useInitializeEppo';

export const EppoContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const eppoClient = useInitializeEppo();

  return (
    <EppoContext.Provider value={eppoClient}>{children}</EppoContext.Provider>
  );
};
